<div
  class="container"
  [ngClass]="{ 'calendar-modification': calendarModification }">
  <button
    class="no-style cat-items all-item"
    aria-label="Show all Calendar Entries"
    [ngClass]="{ 'filter-enabled': !(topicsFilter$ | async)?.allItemsFilter }"
    (click)="resetCategoryFilter()">
    <p>{{ 'season-overview.calendar.all' | translate }}</p>
  </button>
  @for (category of (topicsFilter$ | async)?.categories; track category.type) {
    <button
      class="no-style  cat-items border--{{ category.type }} {{
        category.active && !(topicsFilter$ | async)?.allItemsFilter ? 'active active--' + category.type : ''
      }}"
      aria-label="Filter Calendar"
      (click)="updateVisibleTopics(category.type)">
      <p class="color--{{ category.type }}">
        <i class="material-icons icon--{{ category.type }}"></i>
        {{ 'season-overview.calendar.' + category.type | translate }}
      </p>
    </button>
  }
</div>
